<script setup lang="ts">
    import { ref, watch } from 'vue';
    import TextInput, { TextInputWidth } from '../TextInput.vue';
    import CoachingFormTable from './table/CoachingFormTable.vue';
    import { __ } from '@/js/stores/expressions';
    import VersionHistory from './VersionHistory.vue';
    import CheckboxInput from '../CheckboxInput.vue';
    import { useCoachingFormTableData } from '@/js/stores/coaching-form-table';
    import { debounce } from '@/js/utils/debounce';
    import { SearchIcon } from '@lucide/vue';

    const activeVersionHistory = ref<string | null>(null);

    const coachingFormTableData = useCoachingFormTableData();

    const search = ref<string>(coachingFormTableData.search ?? '');
    const showInactive = ref<boolean>(coachingFormTableData.showInactive === 'true');
    watch(
        search,
        debounce((newVal: string) => {
            coachingFormTableData.changeFilter('search', newVal);
        }, 200)
    );

    watch(showInactive, (newVal) => {
        coachingFormTableData.changeFilter('showInactive', newVal ? 'true' : 'false');
    });
</script>
<template>
    <div class="flex gap-10 items-center pb-12">
        <TextInput
            v-model="search"
            :width="TextInputWidth.Large"
            :placeholder="__('coaching-form-table-search-placeholder')"
        >
            <template #end-adornment><SearchIcon /></template>
        </TextInput>
        <label class="heading-sm flex items-start py-0.5 whitespace-nowrap cursor-pointer">
            <CheckboxInput id="showInactive" v-model="showInactive">
                {{ __('show-inactive-forms') }}
            </CheckboxInput>
        </label>
    </div>

    <CoachingFormTable @show-version-history="activeVersionHistory = $event" />

    <VersionHistory v-model="activeVersionHistory" />
</template>
